import { createFetchActionCreators } from '@navinc/utils'
import { isomorphicFetchWrapper } from './isomorphic-fetch-wrapper.js'

const FETCH = 'fetch'

const createActionCreators = (action) => {
  const {
    loadActionCreator,
    loadActionTypeOrCreator,
    failureActionCreator,
    failureActionTypeOrCreator,
    successActionCreator,
    successActionTypeOrCreator,
  } = action

  const fetchActionCreators = createFetchActionCreators({
    ...(loadActionTypeOrCreator &&
      typeof loadActionTypeOrCreator !== 'function' && {
        loadActionType: loadActionTypeOrCreator,
      }),
    ...(failureActionTypeOrCreator &&
      typeof failureActionTypeOrCreator !== 'function' && {
        failureActionType: failureActionTypeOrCreator,
      }),
    ...(successActionTypeOrCreator &&
      typeof successActionTypeOrCreator !== 'function' && {
        successActionType: successActionTypeOrCreator,
      }),
  })

  return {
    loadActionCreator: fetchActionCreators.loadActionCreator || loadActionTypeOrCreator || loadActionCreator,
    failureActionCreator:
      fetchActionCreators.failureActionCreator || failureActionTypeOrCreator || failureActionCreator,
    successActionCreator:
      fetchActionCreators.successActionCreator || successActionTypeOrCreator || successActionCreator,
  }
}

export const fetchMiddleware =
  (store) =>
  (next) =>
  (action = {}) => {
    if (action.type !== FETCH) {
      return next(action)
    }

    const { payload, requestParams } = action

    const actionCreators = createActionCreators(action)

    if (actionCreators.loadActionCreator) {
      store.dispatch(actionCreators.loadActionCreator(payload))
    }
    return isomorphicFetchWrapper(requestParams)
      .then((data) => {
        const isGraphql = !!requestParams?.body?.query
        if (isGraphql) {
          if (data.data && actionCreators.successActionCreator) {
            store.dispatch(actionCreators.successActionCreator(data.data, payload))
          }
          if (data.errors) return Promise.reject({ data })
        } else if (actionCreators.successActionCreator) {
          store.dispatch(actionCreators.successActionCreator(data, payload))
        }

        return data
      })
      .catch(({ body, status, data = {} }) => {
        const errors = data.errors || (body?.errors ?? [])
        const error = {
          errors,
          status,
        }

        if (actionCreators.failureActionCreator) {
          store.dispatch(actionCreators.failureActionCreator(error, payload))
        }

        return Promise.reject({ ...error, ...data })
      })
  }
